<div class="backdrop" (click)="onClose()"></div>
<div class="about-box">
    <img class="mx-auto d-block" src="../../../../assets/img/logo_completo.jpg" alt="Traduco">
    <strong>ver. 3.11.7</strong><br>
    <p>Istituto di Linguistica Computazionale "A. Zampolli" CNR - Pisa Italy</p>
    <a href="http://www.ilc.cnr.it/" target="_blank" rel="noopener noreferrer">ILC-CNR</a><br>
    <p>Progetto Traduzione Talmud Babilonese</p>
    <a href="https://www.talmud.it/" target="_blank" rel="noopener noreferrer">PTTB</a>
    <div class="about-box-actions">
        <button class="btn btn-primary" (click)="onClose()">{{ 'close' | translate }}</button>
    </div>
</div>